import { render, staticRenderFns } from "./IssueEdit.vue?vue&type=template&id=0d9648c0&"
import script from "./IssueEdit.vue?vue&type=script&lang=js&"
export * from "./IssueEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports